<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <section class="index-dashboard index-dashboard-loader">
    <div class="card mb-20">
      <div>
        <Skeleton width="120px" height="20px" class="mb-10" />
        <Skeleton width="150px" height="25px" />
      </div>
      <div>
        <Skeleton width="120px" height="20px" class="mb-10" />
        <Skeleton width="150px" height="25px" />
      </div>
      <div>
        <Skeleton width="120px" height="20px" class="mb-10" />
        <Skeleton width="150px" height="25px" />
      </div>
      <div>
        <Skeleton width="120px" height="20px" class="mb-10" />
        <Skeleton width="150px" height="25px" />
      </div>
      <div>
        <Skeleton width="120px" height="20px" class="mb-10" />
        <Skeleton width="150px" height="25px" />
      </div>
    </div>
    <div class="mb-20">
      <div class="card mr-20">
        <div>
          <Skeleton width="190px" height="18px" />
          <ElDivider class="mb-20 mt-20" />
          <Skeleton width="auto" height="auto" />
        </div>
      </div>
      <div class="card">
        <div>
          <Skeleton width="190px" height="18px" />
          <ElDivider class="mb-20 mt-20" />
          <Skeleton width="auto" height="auto" />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="mb-20">
        <div>
          <div>
            <Skeleton height="12px" width="163px" class="mr-12 mt-10 mb-0" />
          </div>
          <div>
            <Skeleton height="34px" width="200px" class="mr-12" />
          </div>
        </div>
        <div>
          <div>
            <Skeleton height="34px" width="80px" class="mr-12" />
            <Skeleton height="34px" width="212px" />
          </div>
        </div>
      </div>
      <Skeleton width="auto" height="auto" />
    </div>
  </section>
</template>

<script>
import Skeleton from '@/components/Skeleton';

export default {
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss" scoped>
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/dashboard/index';
</style>
